import { showNotification } from "../../../Common/CommonNotification";

const UENStep = ({ amount, currencyCode, verificationCode }) => {
  const uenNumber = "200609555W";
  const entityName = "Steadfast Money Transfer Pte. Ltd.";

  return (
    <div className="pt-0">
      <div
        className="d-flex justify-content-between align-items-center p-3 rounded-3 mb-4"
        style={{ backgroundColor: "#f8faff" }}
      >
        <span className="fw-bold">Top up amount</span>
        <span className="text-black fw-bold fs-16">
          {amount} {currencyCode}
        </span>
      </div>

      <div className="mb-2">
        <div className="border rounded-2 p-3 bg-white mb-4">
          <div className="mb-3">
            <p className="text-muted mb-1 fs-14">Unique entity number (UEN)</p>
            <h4 className="fw-bold text-black fs-16 mb-0">{uenNumber}</h4>
          </div>

          <div>
            <p className="text-muted mb-1 fs-14">
              Transaction verification code
            </p>
            <div className="d-flex align-items-center">
              <h4 className="fw-bold fs-16 text-black mb-0 me-2">
                {verificationCode}
              </h4>
              <i
                className="far fa-copy text-muted cursor-pointer fs-14"
                onClick={() => {
                  navigator.clipboard.writeText(verificationCode);
                  showNotification(
                    "Verification code copied to clipboard",
                    "success",
                  );
                }}
              ></i>
            </div>
          </div>
        </div>

        <p className="text-muted fs-13 mb-2">
          Check that entity name is "{entityName}"
        </p>

        <div
          className="p-2 rounded-2"
          style={{ backgroundColor: "#f8faff", border: "1px solid #eef2ff" }}
        >
          <div className="d-flex gap-3 mb-3 pt-1">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                backgroundColor: "#FEF9C3",
                width: "32px",
                height: "32px",
              }}
            >
              <i className="fas fa-exclamation text-warning"></i>
            </div>
            <p className="mb-0 fs-13 text-muted" style={{ lineHeight: "1.5" }}>
              Please enter the{" "}
              <span className="fw-bold text-black">
                EXACT Transaction Verification Code
              </span>{" "}
              in your transfer description. If the code is missing/incorrect,
              you must contact Support.
            </p>
          </div>
          <div className="d-flex gap-3 pb-1">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                backgroundColor: "#FFEDD5",
                width: "32px",
                height: "32px",
              }}
            >
              <i
                className="far fa-clock text-orange"
                style={{ color: "#F97316" }}
              ></i>
            </div>
            <p className="mb-0 fs-13 text-muted" style={{ lineHeight: "1.5" }}>
              Please allow up to 2 hours during business hours for the top-up
              amount to be reflected in your main balance. Until then, the
              amount will be shown as "pending".
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UENStep;
